import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Table,
  Spinner,
} from "reactstrap";
import swal from "sweetalert2";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import logo from "../../../../assets/images/karak_logo_new.png";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
  mapUnits,
} from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import showNotification from "../../../../helpers/show_notification";

const ItemsPOCostingReport = (props) => {
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [grandTotal, setGrandTotal] = useState(0);
  const [filterModalTotal, setFilterModalTotal] = useState(0);
  const [filterModalSubTotal, setFilterModalSubTotal] = useState(0);
  const [filterModalTotalQty, setFilterModalTotalQty] = useState([]);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
  }, []);

  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [isLoadingBranchDetails, setIsLoadingBranchDetails] = useState(false);
  const [isLoadingPurchaseDetails, setIsLoadingPurchaseDetails] =
    useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);
  const branchDetailsRequestId = useRef(0);
  const searchSigRef = useRef("");

  function afterFilter(newResult, newFilters) {
    //console.log(newResult);
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.receiving_cost),
      0,
    );
    setFilterModalTotal(total.toFixed(2));
  }

  function afterSearch(newResult, newFilters) {
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.total_cost),
      0,
    );
    // console.log(total,"total");

    setFilteredOrders((prevOrders) => {
      const sig = `${newResult.length}:${Number(total.toFixed(2))}`;
      if (searchSigRef.current === sig) return prevOrders;
      searchSigRef.current = sig;
      return newResult;
    });

    setGrandTotal(Number(total.toFixed(2)));
  }

  function afterFilterForDetails(
    newData,
    quantityField,
    detailsType = "delivery_details",
  ) {
    const data = newData;
    let totalCost = 0;
    let totalLowestUnitQty = 0;

    data.forEach((item) => {
      const details = item[detailsType];
      const {
        receiving_cost = 0,
        unit_levels,
        received_quantity,
        receive,
        quantity,
      } = details || {};

      totalCost += Number(receiving_cost || 0);

      if (unit_levels) {
        const quantityToBeDisplayed =
          quantityField === "received_quantity"
            ? received_quantity
            : quantityField === "receive"
              ? receive
              : quantity;

        if (quantityToBeDisplayed) {
          const convertedQty = convertToLowestUnit(
            unit_levels,
            quantityToBeDisplayed,
          );
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      }
    });
    let displayQuantity = "";
    const firstItemDetails = data[0]?.[detailsType];
    if (firstItemDetails?.unit_levels) {
      const { unit_levels } = firstItemDetails;
      const lowestUnit = unit_levels.at(-1).unit;

      const summedQuantity = [
        {
          unit: lowestUnit,
          value: totalLowestUnitQty,
        },
      ];

      displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
    }
    setFilterModalTotalQty(displayQuantity);
    setFilterModalSubTotal(totalCost.toFixed(2));
  }

  const [allOrders, setAllOrders] = useState([]);

  const loadOrders = async () => {
    if (!dateFrom || !dateTo) return;
    const requestId = ++ordersRequestId.current;
    try {
      setIsLoadingOrders(true);
      let url = process.env.REACT_APP_BASEURL + "purchaseorders/costing";
      const response = await postSubmitForm(url, {
        date_from: dateFrom,
        date_to: dateTo,
        summary_only: true,
      });
      if (requestId !== ordersRequestId.current) return;
      if (response && response.status === 1) {
        setAllOrders(response.data.branches || []);
        setTablePage(1);
        setGrandTotal(
          response.data.grand_total_cost.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
        );
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
      showNotification(error, "Error");
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };
  const [orderStatus, setOrderStatus] = useState("All");
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    if (allOrders.length > 0) {
      if (orderStatus === "All") {
        setFilteredOrders([...allOrders]);
      } else {
        let arr = allOrders.filter((order) => order.status === orderStatus);
        setFilteredOrders(arr);
      }
    }
  }, [allOrders, orderStatus]);

  const [purchaseDetailsModal, setPurchaseDetailsModal] = useState(false);
  const [purchaseDetails, setPurchaseDetails] = useState([]);

  const loadPurchaseDetails = async (item_id) => {
    try {
      setIsLoadingPurchaseDetails(true);
      setPurchaseDetails([]);
      setPurchaseDetailsModal(true);
      let url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_costing_summary_po";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        from_cogs: true,
        item_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { delivery_details } = item;
          const {
            receiving_cost = 0,
            unit_levels,
            receive,
          } = delivery_details || {};

          totalReceivingCost += Number(receiving_cost);

          if (unit_levels && receive) {
            const convertedQty = convertToLowestUnit(unit_levels, receive);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.delivery_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setPurchaseDetails(response.data);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingPurchaseDetails(false);
    }
  };

  const loadBranchDetails = async (row) => {
    const requestId = ++branchDetailsRequestId.current;
    try {
      setSelectedBranch(row);
      setSelectedRow({ ...row, item_details: [] });
      setFilterModalTotal(row.total_cost);
      setPoModal(true);
      setIsLoadingBranchDetails(true);
      const url = process.env.REACT_APP_BASEURL + "purchaseorders/costing";
      const response = await postSubmitForm(url, {
        date_from: dateFrom,
        date_to: dateTo,
        branch_id: row._id,
      });
      if (requestId !== branchDetailsRequestId.current) return;
      if (response && response.status === 1) {
        const branch =
          (response.data.branches || []).find(
            (item) => String(item._id) === String(row._id),
          ) ||
          (response.data.branches || [])[0] ||
          row;
        const uniqueItems = mergeDuplicateItems(branch.item_details);
        setSelectedRow({
          ...row,
          ...branch,
          item_details: uniqueItems,
        });
        setFilterModalTotal(branch.total_cost || row.total_cost);
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      if (requestId !== branchDetailsRequestId.current) return;
      showNotification(error, "Error");
    } finally {
      if (requestId === branchDetailsRequestId.current) {
        setIsLoadingBranchDetails(false);
      }
    }
  };

  const [poModal, setPoModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);

  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return (tablePage - 1) * pageSize + rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },

    {
      dataField: "total_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadBranchDetails(row);
            }}
          >
            {row.total_cost}
          </span>
        );
      },

      style: { cursor: "pointer" },
    },
  ];

  function mergeDuplicateItems(items) {
    if (!items?.length) return [];

    return Object.values(
      items.reduce((acc, item) => {
        if (!acc[item.item_id]) {
          acc[item.item_id] = { ...item, is_free: item.is_free || false };
        } else {
          // Convert both quantities to lowest unit and sum them
          const convertedQty = convertToLowestUnit(
            item.unit_levels,
            item.receive,
          );
          const existingQty = convertToLowestUnit(
            acc[item.item_id].unit_levels,
            acc[item.item_id].receive,
          );
          const lowestUnit = item.unit_levels.at(-1).unit;

          const summedQuantity = [
            { unit: lowestUnit, value: Number(convertedQty + existingQty) },
          ];

          acc[item.item_id].receive = GetUpdatedDelivered(
            summedQuantity,
            item.unit_levels,
          );
          acc[item.item_id].receiving_cost += Number(item.receiving_cost);
          acc[item.item_id].is_free = acc[item.item_id].is_free || item.is_free;
        }
        return acc;
      }, {}),
    );
  }

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadPurchaseDetails(row.item_id);
            }}
          >
            {row.name}{" "}
            <span
              hidden={!row.is_free}
              className="text-danger"
              style={{ fontSize: "20px" }}
            >
              *
            </span>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "receive",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return <>{formatUnitsForReport(row.receive)}</>;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Purchasing Unit"),
      dataField: "unit_for_po",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "price",
      text: props.t("Price (QR)"),
      formatter: (cell, row) => {
        // return row?.price + "/" + row?.unit_for_po
        return row?.price;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "receiving_date",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.receiving_date).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  const columnsPurchaseDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "delivery_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      dataField: "delivery_details.unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.delivery_details?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivery_details.receive);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "delivery_details.is_free",
      text: props.t("Free ?"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "delivery_details.unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "delivery_details.cost_price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.delivery_details.cost_price + "/" + row?.delivery_details?.unit_for_po
      //  },
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return row?.delivery_details?.free_cost_price;
        } else {
          return row?.delivery_details?.cost_price;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "delivery_details.receiving_cost",
      text: props.t("Receiving Cost"),
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return (
            <div>
              <div>Projected: {row?.delivery_details?.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.delivery_details?.receiving_cost}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "receiving_datetime",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.receiving_datetime).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "PO_costing_report";
    const exportType = "xls";

    let data_to_export = filteredOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Name: v.name,
          Total_cost: v.total_cost,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("PO Costing Report - Items")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("PO Costing Report - Items")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("PO Costing Report (Items)")} <br />
                      <h6>
                        (PO Costing Report : PO created by CSM for branch + PO
                        Created by branch.)
                      </h6>
                    </CardTitle>
                    <ToolkitProvider
                      keyField="_id"
                      data={allOrders || []}
                      columns={columns_external}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                                delay={500}
                                onSearch={(searchText) => {
                                  if (!searchText || searchText.trim() === "") {
                                    toolkitProps.searchProps.onSearch(
                                      searchText,
                                    );
                                    afterSearch(toolkitProps.baseProps.data);
                                    return;
                                  }
                                  if (searchText?.length <= 3) return;
                                  const needle = searchText.toLowerCase();
                                  const searchResult = (
                                    toolkitProps.baseProps.data || []
                                  ).filter((row) =>
                                    String(row.name || "")
                                      .toLowerCase()
                                      .includes(needle),
                                  );

                                  toolkitProps.searchProps.onSearch(searchText);
                                  afterSearch(searchResult);
                                }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}>
                              <h5>
                                {" "}
                                Grand Total : QR{" "}
                                {grandTotal.toLocaleString("en-QA", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </h5>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            pagination={paginationFactory(pagination_options)}
                            filter={filterFactory({ afterSearch })}
                            rowStyle={rowStyle}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal size="lg" isOpen={poModal} toggle={() => setPoModal(!poModal)}>
            <ModalHeader toggle={() => setPoModal(!poModal)}>
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv1");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv1">
                <Col lg={4}>
                  <img
                    src={logo}
                    alt=""
                    height="50"
                    style={{ borderRadius: "5px" }}
                  />
                </Col>
                <Col lg={12}>
                  <CardTitle className="text-center">
                    {props.t("PO Costing Details")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            {" "}
                            Branch: {selectedRow.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={
                              selectedRow.item_details &&
                              selectedRow.item_details
                            }
                            columns={columns}
                            striped
                            hover
                            condensed
                            filter={filterFactory({ afterFilter })}
                            rowStyle={rowStyle}
                            noDataIndication={
                              isLoadingBranchDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/* Purchase breakup details modal       */}
          <Modal
            size="xl"
            isOpen={purchaseDetailsModal}
            toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
          >
            <ModalHeader
              toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivPurchaseitem");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivPurchaseitem">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("PO Costing Details")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>

                  <CardTitle className="text-center">
                    {props.t("(Purchase Item Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={purchaseDetails && purchaseDetails}
                            columns={columnsPurchaseDetails}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "receive",
                                    "delivery_details",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            condensed
                            rowStyle={rowStyle}
                            noDataIndication={
                              isLoadingPurchaseDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemsPOCostingReport)),
);
